import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef } from "@angular/material/dialog";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Http, Headers } from '@angular/http';
import { AngularFirestore } from 'angularfire2/firestore';
import { ApiService } from '../../../../core/services/api.service';

@Component({
    selector: 'app-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.css']
})
export class DialogComponent implements OnInit {
    modalType: any;
    constructor(
        public dialogRef: MatDialogRef<DialogComponent>,
        private afs: AngularFirestore,
        private http: Http,
        private api: ApiService,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        console.log(data);
        this.modalType = data.type;
    }

    ngOnInit() {
    }

    close() {
        this.dialogRef.close();
    }

    async delete() {
        console.log(this.data.key)

        this.api.sqlDelete('users/Deleteuser', this.data.key).toPromise().then(a => a);
        await this.afs.collection('users').doc(this.data.key).ref.get().then((snap) => {
            this.afs.collection('deletedUsers').doc(this.data.key).set(snap.data()).then(() => {
                this.afs.collection('users').doc(this.data.key).collection('followIng').ref.get().then((following => {
                    if (!following.empty) {
                        following.forEach(user => {
                            if (user.data().type === 'user') {
                                this.afs.collection('users').doc(user.id).collection('followEr').doc(this.data.key).delete();
                            }
                            if (user.data().type === 'brand') {
                                this.afs.collection('brands').doc(user.id).collection('followEr').doc(this.data.key).delete();
                            }
                            if (user.data().type === 'product') {
                                this.afs.collection('products').doc(user.id).collection('followEr').doc(this.data.key).delete();
                            }
                        });

                    }
                })).then(() => {
                    this.afs.collection('users').doc(this.data.key).collection('followEr').ref.get().then((follower) => {
                        if (!follower.empty) {
                            follower.forEach(user => {
                                if (user.data().type === 'user') {
                                    this.afs.collection('users').doc(user.id).collection('followIng').doc(this.data.key).delete();
                                }
                            })
                        }

                    })
                }).then(() => {


                    this.afs.collection('entities').ref.where('uniqueName', '==', snap.data().username).get().then((entities => {

                        this.afs.collection('entities').doc(entities.docs[0].id).delete();
                    }))
                })
                    .then(() => {
                        this.afs.collection('posts').ref.where('author.username', '==', snap.data().username).get().then((posts => {
                            if (posts) {
                                posts.forEach(dataPosts => {

                                    this.afs.collection('posts').doc(dataPosts.id).delete();
                                });
                            }
                        }))
                    })
                    .then(() => {

                        this.afs.collection('posts').ref.where('repostedByUser.username', '==', snap.data().username).get().then((userID) => {
                            userID.forEach(post => {

                                this.afs.collection('posts').doc(post.id).delete();
                            })
                        }).then(() => {
                            this.afs.collection('posts').ref.where('repostedFrom.username', '==', snap.data().username).get().then((repostedFrom => {
                                repostedFrom.docs.map(post => {
                                    this.afs.collection('posts').doc(post.id).delete();
                                });
                            }));
                        })
                    }).then(() => {
                        this.api.sqlDeleteuniquename('users/removeByUniquename',
                            snap.data().username).toPromise()

                    }).then(() => {
                        this.afs.collection('posts').ref.orderBy('comments').get().then(data => {
                            let arr = [];
                            data.docs.map(a => {
                                a.data().comments.forEach(b => {

                                    if (b.user.username == snap.data().username) {

                                        arr = a.data().comments.filter(comment => {
                                            return comment.user.username !== snap.data().username
                                        });
                                        this.afs.collection('posts').doc(a.id).update({
                                            comments: arr
                                        });


                                    }
                                });
                            });

                        });
                    })
                    .then(() => {
                        this.afs.collection('users').doc(this.data.key).delete();
                    });

            });

        });
        this.dialogRef.close();

    }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/users/dialog/dialog.component.ts